// "icon/gift" from the Web Homepage Figma (3668:439).
export const GiftIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M13.6667 4.66667H2.33333C1.78105 4.66667 1.33333 5.11438 1.33333 5.66667V7C1.33333 7.55228 1.78105 8 2.33333 8H13.6667C14.219 8 14.6667 7.55228 14.6667 7V5.66667C14.6667 5.11438 14.219 4.66667 13.6667 4.66667Z"
      fill="#2F7D4F"
    />
    <path
      d="M2.66667 9H13.3333V12.6667C13.3333 13.0203 13.1929 13.3594 12.9428 13.6095C12.6928 13.8595 12.3536 14 12 14H4C3.64638 14 3.30724 13.8595 3.05719 13.6095C2.80714 13.3594 2.66667 13.0203 2.66667 12.6667V9Z"
      fill="#2F7D4F"
    />
    <path d="M8 4.66667V14" stroke="white" />
    <path
      d="M8 4.66667C6 4.66667 4.66667 4 4.66667 3C4.66667 2 5.66667 1.66667 6.66667 2.33333C7.66667 3 8 4.66667 8 4.66667ZM8 4.66667C10 4.66667 11.3333 4 11.3333 3C11.3333 2 10.3333 1.66667 9.33333 2.33333C8.33333 3 8 4.66667 8 4.66667Z"
      fill="#2F7D4F"
    />
  </svg>
);
